import { navigate } from 'hookrouter'
import axios from 'axios'
import { apis } from 'store/apis'
import { notify } from 'store/notification/actions'
import { useDispatch } from 'react-redux'

export enum EmailKind {
  None = 'none',
  ContactPressService = 'contact_press_service',
  ContactRecruitment = 'contact_recruitment',
  ContactFiberPartnership = 'contact_fiber_partnership',
  ContactInstitutionalRelations = 'contact_institutional_relations',
  ContactSubscriberRelation = 'contact_subscriber_relation',
  ContactRse = 'contact_rse',
  NewsletterSubscribe = 'newsletter_subscribe',
  NewsletterUnsubscribe = 'newsletter_unsubscribe'
}

export interface ISendEmail {
  type: EmailKind
  language: string
  from: string
  message?: string
  successMessage?: string
  route?: string
  errorMessage: string
  subject?: string
}

export const useEmail = () => {
  const dispatch = useDispatch()

  return ({ type, language, from, message, successMessage, errorMessage, route, subject }: ISendEmail) => {
    axios
      .post(apis.email.sendApi(), { from, language, message, type, subject })
      .then(() => {
        if (successMessage) {
          dispatch(notify(successMessage, 'success'))
        }

        if (route) {
          navigate(route)
        }
      })
      .catch(() => notify(errorMessage, 'error'))
  }
}
